import React, {Fragment, useEffect, useState} from "react";
import classNames from "classnames";
import { debounce } from "debounce";

import getListingSettings from "../utils/getListingSettings";
import client from "../utils/client";

import TAGS from "../queries/tags";
import LISTING_LIST from "../queries/listingList";
import FavButton from "./FavButton";
import Listing from "./Listing";

const ListingIndex = () => {

    const settings = getListingSettings();

    const limit = 8;

    const [nofFeaturedListings, setNOFFeaturedListings] = useState(0);
    const [loading, setLoading] = useState(true);
    const [tags, setTags] = useState([]);
    const [keywords, setKeywords] = useState('');
    const [tmpKeywords, setTmpKeywords] = useState('');
    const [listings, setListings] = useState([]);
    const [filterTag, setFilterTag] = useState(undefined);
    const [offset, setOffset] = useState(0);
    const [hasNextPage, setHasNextPage] = useState(false);

    useEffect(() => {
        if (settings.tags && settings.tags.length) {
            loadTags();
        }
        loadListings();
    }, []);

    useEffect(() => {
        loadListings();
    }, [filterTag, keywords]);

    const loadTags = () => {
        client.query({
            query: TAGS,
            variables: {
                ids: settings.tags
            }
        }).then(({data}) => {
            setTags(data.tags);
        });
    }

    const filterListings = (tag) => {
        setOffset(0);
        setNOFFeaturedListings(0);
        setListings([]);
        setHasNextPage(false);
        if (filterTag !== tag) {
            setFilterTag(tag);

        } else {
            setFilterTag(undefined);
        }
    }

    const clearFilter = () => {

        if (filterTag){
            setListings([]);
            setOffset(0);
            setNOFFeaturedListings(0);
            setFilterTag(undefined);
        }
    }

    const clearKeywords = () => {
        setListings([]);
        setOffset(0);
        setNOFFeaturedListings(0);
        setKeywords('');
        setTmpKeywords('');
    }

    const submitKeywordSearch = () => {
        console.log('TT', tmpKeywords);
        if (tmpKeywords) {
            setListings([]);
            setOffset(0);
            setKeywords(tmpKeywords);
        }
    }

    const loadListings = () => {
        setLoading(true);
        let listingType = null;
        if (settings.eventsPage) {
            listingType = 'Events';
        }
        if (settings.accommodationsPage) {
            listingType = 'Accommodations';
        }

        client.query({
            query: LISTING_LIST,
            variables: {
                keywords: keywords,
                tags: filterTag ? [filterTag] : [],
                categories: settings.categories && settings.categories.length > 0 ? settings.categories : [],
                listingType: listingType,
                offset: offset,
                limit: limit
            }
        }).then(({data}) => {
            let featuredCount = 0;
            const ls = data.listings.edges.map((l) => {
                if (l.node.Featured) {
                    featuredCount += 1;
                }
                return l.node;
            });

            setNOFFeaturedListings(nofFeaturedListings + featuredCount);
            setListings([...listings, ...ls]);
            setHasNextPage(data.listings.pageInfo.hasNextPage);
            setOffset(offset + limit);
            setLoading(false);
        });
    }

    return <div className="container">
        <div className="listing-index">

            {tags.length > 0 && <Fragment>
                <div className="listing-index__mobile-filters dropdown">
                    <select value={filterTag} onChange={(e) => {
                        filterTag === undefined ? filterListings(e.target.value) :  clearFilter()
                    }}>
                        <option value={''}>Filter Tags</option>
                        {tags.map((tag) => {
                            return <option key={tag.Identifier} value={tag.Identifier}>{tag.Title}</option>
                        })}
                       {filterTag !== undefined && <option value={''}>Clear Filter</option>}
                    </select>
                </div>
                <div className="listing-index__filters">
                    <div className="listing-index__tags">
                        <h2>Filter Tags:</h2>
                        <div>
                            <ul>
                                {tags.map((tag) => {
                                    return <li key={tag.Identifier}>
                                        <a href="#"
                                           className={tag.Identifier === filterTag ? "btn btn--solid btn--solid--liteGray active" : "btn btn--solid btn--solid--liteGray"}
                                           onClick={(e) => {
                                               e.preventDefault();
                                               filterListings(tag.Identifier)
                                               return false;
                                           }}>{tag.Title}</a>

                                    </li>
                                })}
                                <li>
                                    <a href='#'
                                       className={filterTag === undefined ? "btn btn--solid btn--solid--liteGray btn--clear " : "btn btn--solid btn--solid--liteGray"}
                                       onClick={(e)=>{
                                        e.preventDefault()
                                        clearFilter()
                                       }}
                                      >
                                        Clear All
                                    </a>
                                </li>
                            </ul>
                        </div>
                    </div>
                    <div className="listing-index__keywords">
                        <h2>Search listings:</h2>
                        <div className={'listing-index__input'}>
                            <input type={'text'} placeholder={'Search'} value={tmpKeywords}
                                   onKeyUp={(e) => {
                                       if (e.keyCode === 13) {
                                           submitKeywordSearch();
                                       }
                                   }}
                                   onChange={(e) => {
                                        e.preventDefault();
                                        setTmpKeywords(e.target.value);
                                    }} />
                            <img src="_resources/themes/horowhenua/dist/img/icons/search.svg" alt="" />
                        </div>
                        <div className={'listing-index__buttons'}>
                            <ul>
                                <li>
                                    <a href={'#'}
                                       className={'btn btn--solid btn--solid--liteGray'}
                                       onClick={(e) => {
                                           e.preventDefault();
                                           clearKeywords();
                                       }}
                                    >
                                        Clear search
                                    </a>
                                </li>
                                {/*<li>*/}
                                {/*    <a href={'#'}*/}
                                {/*       className={'btn btn--solid btn--solid--navy'}*/}
                                {/*        onClick={(e) => {*/}
                                {/*            e.preventDefault();*/}
                                {/*            submitKeywordSearch();*/}
                                {/*        }}>*/}
                                {/*        Submit*/}
                                {/*    </a>*/}
                                {/*</li>*/}
                            </ul>
                        </div>
                    </div>

                </div>
            </Fragment>}

            {!!loading && <div className="listing-index__loading">Loading</div>}

            {listings.length > 0 && <div className="listing-index__grid">
                {listings.map((listing, index) => {

                    return <Listing key={index} listing={listing}
                                    index={index}
                                    urlBase={settings.link}
                                    displayFeatures={true}
                                    nofFeaturedListings={nofFeaturedListings} />
                })}
            </div>}

            {!!hasNextPage && <div className="listing-index__more">
                <a onClick={(e) => { e.preventDefault(); loadListings(); return false; }}
                   className="btn btn--hollow btn--hollow--navy">
                    Load more
                </a>
            </div>}
        </div>
    </div>

}

export default ListingIndex;
